import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import {BrowserRouter as Router} from 'react-router-dom';
import * as serviceWorker from './serviceWorker';
import store from './redux/store';
import {Provider} from 'react-redux';

ReactDOM.render(
  <Router basename={process.env.NODE_ENV === 'production'?'/chaperone-apihub':''}>
      <Provider store={store}>
          <App/> 
      </Provider>
  </Router>,
  document.getElementById('root')
);
serviceWorker.unregister();
